

import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core'

@Component({
  selector: 'pager',
  templateUrl: './pager.component.html',
  standalone: false
})
export class PagerComponent implements OnChanges {
  @Input() totalItems!: number;
  @Input() itemsPerPage!: number;

  @Input() firstText = 'First';
  @Input() lastText = 'Last';
  @Input() nextText = '>';
  @Input() previousText = '<';
  @Input() page = 1;
  @Output() pageChanged = new EventEmitter<{page: number}>();

  totalPages = 1;

  ngOnChanges() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  }

  goTo(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.page = page;
    this.pageChanged.emit({ page });
  }
}